"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastAnimated = exports.showToast = void 0;
const react_1 = __importDefault(require("react"));
const react_toastify_1 = require("react-toastify");
require("react-toastify/dist/ReactToastify.css");
const colors_1 = require("@material-ui/core/colors");
const styles_1 = require("@material-ui/core/styles");
const CheckCircle_1 = __importDefault(require("@material-ui/icons/CheckCircle"));
const Error_1 = __importDefault(require("@material-ui/icons/Error"));
const Info_1 = __importDefault(require("@material-ui/icons/Info"));
const Warning_1 = __importDefault(require("@material-ui/icons/Warning"));
const useStyles = styles_1.makeStyles(theme => ({
    materialStyleToastify: {
        '&.Toastify__toast-container': {
            [theme.breakpoints.up('md')]: {
                maxWidth: '60vw',
            },
            [theme.breakpoints.up('sm')]: {
                width: 'auto',
            },
            [theme.breakpoints.down('xs')]: {
                padding: '10px',
            },
        },
        '& .Toastify__toast--info': {
            background: theme.palette.primary.main,
        },
        '& .Toastify__toast--success': {
            background: colors_1.green[600],
        },
        '& .Toastify__toast--warning': {
            background: colors_1.amber[700],
        },
        '& .Toastify__toast--error': {
            background: theme.palette.error.dark,
        },
        '& .icon': {
            fontSize: 20,
        },
        '& .iconVariant': {
            opacity: 0.9,
            marginRight: theme.spacing(1),
        },
        '& .message': {
            display: 'flex',
            alignItems: 'center',
            fontSize: 18,
        },
    },
}));
const variantIcon = {
    success: CheckCircle_1.default,
    warning: Warning_1.default,
    error: Error_1.default,
    info: Info_1.default,
};
const showToast = ({ variant = 'warning', mensagem, position = react_toastify_1.toast.POSITION.TOP_RIGHT, autoClose = variant === 'error' ? false : variant === 'success' ? 3000 : 4000, onOpen, onClose, closeButton, }) => {
    const config = {
        position,
        autoClose,
        toastId: mensagem,
        onOpen,
        onClose,
        closeButton,
        transition: react_toastify_1.Flip,
    };
    const Icon = variantIcon[variant];
    const Message = () => (react_1.default.createElement("span", { id: "toast", style: { display: 'flex', alignItems: 'center', fontSize: '18px' } },
        react_1.default.createElement(Icon, { style: { fontSize: '20px', opacity: '0.9', marginRight: '5px' } }),
        mensagem));
    switch (variant) {
        case 'success':
            return react_toastify_1.toast.success(Message, config);
        case 'warning':
            return react_toastify_1.toast.warn(Message, config);
        case 'error':
            return react_toastify_1.toast.error(Message, config);
        default:
            return react_toastify_1.toast.info(Message, config);
    }
};
exports.showToast = showToast;
const ToastAnimated = () => {
    const classes = useStyles();
    return (react_1.default.createElement(react_toastify_1.ToastContainer, { className: classes.materialStyleToastify }));
};
exports.ToastAnimated = ToastAnimated;
//# sourceMappingURL=index.js.map